<template lang="pug">
form
  .row
    table.custom-tb-highlight
      tr
        td.text-center.custom-td-highlight(v-for='item in limitHighlight()')
          img.img(:src='item.icon').custom-img-highlight
      tr(style='vertical-align: text-top;')
        td.text-center.custom-td-highlight(v-for='item in limitHighlight()')
          p.txt-highlight {{item.name}}
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'

export default {
  props: {
    user: Object
  },
  methods: {
    limitHighlight() {
      var count = 0
      var lst = []
      if (this.highlights) {
        for (var i = 0; i < this.highlights.length; i++) {
          count++
          if (count <= 3) lst.push(this.highlights[i])
        }
        return lst
      }
    }
  },
  data() {
    return {
      highlights: []
    }
  },
  apollo: {
    'highlights': {
      query: gql(graphql.GET_HIGHLIGHT_USER),
      variables() {
        return {
          user_id: this.$store.getters.user
        }
      },
      update: data => data.achievement
    }
  }
}
</script>

<style lang='scss'>
.custom-tb-highlight {
  width: 100%;
}
.custom-td-highlight {
  width: 33%;
}
.txt-highlight {
  text-align:center;
  // font-family: Proxima Nova;
  color: #9F6A28;
  font-size: 15px;
  // text-align: justify;
  // text-justify: inter-word;
}
.custom-img-highlight {
  width: 80px !important;
  height: 80px !important;
}
@media (max-width: 414px) {
  .custom-img-highlight {
    width: 60px !important;
    height: 60px !important;
  }
}
</style>



// WEBPACK FOOTER //
// Highlight.vue?14a7cecf